import FiveHundredErrorPage from './FiveHundredErrorPage';
import FiveHundredError from './FiveHundredError';

export { FiveHundredError, FiveHundredErrorPage };
